import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "card h-100" }
const _hoisted_5 = { class: "card-body py-2 px-3 d-flex align-items-center justify-content-between" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "card h-100" }
const _hoisted_12 = { class: "card-body py-1 px-2 d-flex align-items-center gap-3" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "bi bi-file-earmark-text",
  style: {"font-size":"2rem","color":"#6c757d"}
}
const _hoisted_16 = { class: "flex-grow-1" }
const _hoisted_17 = {
  class: "text-truncate d-block",
  style: {"max-width":"150px"}
}
const _hoisted_18 = ["onClick"]

import { defineAsyncComponent, onMounted, ref } from "vue";
import * as bootstrap from "bootstrap";
import apiService from "@/services/apiService";
import { toast } from "vue3-toastify";

import BaseForm from "@/components/commen/modal/BaseForm.vue";
import VueMultiselect from "vue-multiselect";

export default /*@__PURE__*/_defineComponent({
  __name: 'createAgents',
  setup(__props) {

const Card9 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData9.vue")
);

// Form data
const formData = ref({
  title: "",
  roles: [] as any[],
  tools: [] as any[],
  description: "",
  link: "", // ✅ single link input
  attachment: [] as any[],
});

// Options for Role & Tools
const roleOptions = ref<any[]>([]);
const toolOptions = ref<any[]>([]);

// Attachments
const attachments = ref<any[]>([]);

// Links
const links = ref<any[]>([]);

// Fields for BaseForm
const formFields = [
  {
    key: "title",
    label: "Title",
    type: "text",
    placeholder: "Enter title",
    required: true,
  },
  {
    key: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Enter description",
    rows: 4,
    required: true,
  },
];

// ✅ Fields for Links
const linkFields = [
  {
    key: "link",
    label: "Link",
    type: "text",
    placeholder: "Enter link (https://...)",
    required: true,
  },
];

// ✅ Fields for Attachments
const attachmentFields = [
  {
    key: "attachment",
    label: "Attachment",
    type: "file",
    placeholder: "Upload attachment",
    required: true,
  },
];

// API calls
const getRoles = async () => {
  try {
    const response = await apiService.get("common/roles");
    if (response) roleOptions.value = response;
  } catch (error) {
    console.error("❌ API Error:", error);
  }
};
const getTools = async () => {
  try {
    const response = await apiService.get("common/tools");
    if (response) toolOptions.value = response;
  } catch (error) {
    console.error("❌ API Error:", error);
  }
};
onMounted(() => {
  getRoles();
  getTools();
});

// ✅ Add Link
function handleAddLink() {
  const link = formData.value.link?.trim();
  if (!link) {
    return;
  }

  links.value.push({
    _id: Date.now().toString(),
    url: link,
  });

  formData.value.link = ""; // reset field
}

// ✅ Delete Link
function deleteLink(id: string) {
  links.value = links.value.filter((l) => l._id !== id);
}

function handleAdd(newValue: any) {
  let fileInput = newValue.attachment;
  if (!fileInput) return;

  // Normalize to single File
  let file: File;
  if (fileInput instanceof FileList) {
    file = fileInput[0];
  } else if (Array.isArray(fileInput)) {
    file = fileInput[0];
  } else {
    file = fileInput;
  }

  if (!(file instanceof File)) {
    console.error("Not a valid File:", fileInput);
    return;
  }

  const isImage = file.type.startsWith("image/");
  const isPdf = file.type === "application/pdf";
  const previewUrl = URL.createObjectURL(file);

  attachments.value.push({
    _id: Date.now().toString(),
    attachment: file,
    attachmentName: file.name,
    preview: previewUrl,
    isImage,
    isPdf,
  });

  formData.value.attachment = null; // reset
}

// ✅ Delete Attachment
function deleteRow(id: string) {
  const file = attachments.value.find((f) => f._id === id);
  if (file?.preview) URL.revokeObjectURL(file.preview);

  attachments.value = attachments.value.filter((f) => f._id !== id);
}

// ✅ Handle Submit
async function handleSubmit() {
  try {
    // ✅ Basic validation
    if (!formData.value.title.trim()) {
      toast.error("Title is required");
      return;
    }
    if (!formData.value.description.trim()) {
      toast.error("Description is required");
      return;
    }

    // ✅ Step 1: Upload attachments first
    const uploadedAttachments: string[] = [];
    if (attachments.value.length > 0) {
      try {
        for (const file of attachments.value) {
          if (file.attachment instanceof File) {
            const uploadedUrl: string = await apiService.uploadFile(
              "upload/file-common",
              file.attachment
            );
            uploadedAttachments.push(uploadedUrl);
          }
        }
      } catch (err) {
        console.error("❌ File upload failed:", err);
        toast.error("Failed to upload attachments");
        return;
      }
    }

    // ✅ Step 2: Build final JSON payload (not FormData)
    const payload = {
      title: formData.value.title.trim(),
      description: formData.value.description.trim(),
      roles: formData.value.roles.map((r: any) => r._id),
      tools: formData.value.tools.map((t: any) => t._id),
      links: links.value.map((l: any) => l.url),
      attachments: uploadedAttachments, // ✅ uploaded file links
    };

    // ✅ Step 3: Send to API
    const response = await apiService.post("common/agents", payload);

    if (response) {
      toast.success("Agent created successfully!");

      // Reset everything
      formData.value = {
        title: "",
        roles: [],
        tools: [],
        description: "",
        link: "",
        attachment: [],
      };
      links.value = [];
      attachments.value.forEach((file: any) => {
        if (file.preview) URL.revokeObjectURL(file.preview);
      });
      attachments.value = [];
    }
  } catch (error) {
    console.error("❌ Submit Error:", error);
    toast.error("Failed to create agent. Please try again.");
  }
}


return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, { title: "create agent" }),
    _createVNode(_unref(Card9), {
      colClass: "col-12",
      cardhaderClass: "pb-0",
      title: "Create Agent",
      desc: ""
    }, {
      default: _withCtx(() => [
        _createVNode(BaseForm, {
          modelValue: formData.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
          fields: formFields
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(VueMultiselect), {
          modelValue: formData.value.roles,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.roles) = $event)),
          options: roleOptions.value,
          multiple: true,
          "close-on-select": false,
          placeholder: "Select Roles",
          label: "title",
          "track-by": "_id",
          class: "mt-3"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_unref(VueMultiselect), {
          modelValue: formData.value.tools,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.tools) = $event)),
          options: toolOptions.value,
          multiple: true,
          "close-on-select": false,
          placeholder: "Select Tools",
          label: "title",
          "track-by": "_id",
          class: "mt-3"
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BaseForm, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData).value = $event)),
            fields: linkFields
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", { class: "col-12 text-end mt-1" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: handleAddLink
            }, " Add Link ")
          ])
        ]),
        (links.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: link._id,
                    class: "col-12 col-sm-6 col-md-3"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "text-truncate d-block",
                          style: {"max-width":"150px"}
                        }, _toDisplayString(link.url), 9, _hoisted_6),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn p-2 btn-sm btn-outline-danger",
                          onClick: ($event: any) => (deleteLink(link._id))
                        }, " ✕ ", 8, _hoisted_7)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseForm, {
            modelValue: formData.value,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((formData).value = $event)),
              handleAdd
            ],
            fields: attachmentFields
          }, null, 8, ["modelValue"])
        ]),
        (attachments.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file._id,
                    class: "col-12 col-sm-6 col-md-3"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          (file.isImage)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: file.preview,
                                alt: "Preview",
                                class: "img-thumbnail",
                                style: {"width":"60px","height":"60px","object-fit":"cover"}
                              }, null, 8, _hoisted_13))
                            : (file.isPdf)
                              ? (_openBlock(), _createElementBlock("embed", {
                                  key: 1,
                                  src: file.preview,
                                  type: "application/pdf",
                                  style: {"width":"60px","height":"60px"}
                                }, null, 8, _hoisted_14))
                              : (_openBlock(), _createElementBlock("i", _hoisted_15))
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(file.attachmentName), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn p-2 btn-sm btn-outline-danger",
                          onClick: ($event: any) => (deleteRow(file._id))
                        }, " ✕ ", 8, _hoisted_18)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "col-12 text-end mt-4" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: handleSubmit
          }, " Submit ")
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})